import { render, staticRenderFns } from "./sub-nav.vue?vue&type=template&id=e1ff8c96&scoped=true&"
import script from "./sub-nav.vue?vue&type=script&lang=js&"
export * from "./sub-nav.vue?vue&type=script&lang=js&"
import style0 from "./sub-nav.vue?vue&type=style&index=0&id=e1ff8c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ff8c96",
  null
  
)

export default component.exports